
  /* Click-to-load. One document-level listener serves every Video feature
     section on the page (and survives theme-editor section reloads). */
  (function () {
    if (window.__fawpVideoFeature) return;
    window.__fawpVideoFeature = true;

    function embedUrl(url) {
      var yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
      if (yt) return 'https://www.youtube-nocookie.com/embed/' + yt[1] + '?autoplay=1&rel=0';
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
      return null;
    }

    function load(frame, btn) {
      var url = frame.getAttribute('data-video-url') || '';
      var srcEl = frame.querySelector('[data-video-sources]');
      var sources = [];
      if (srcEl) { try { sources = JSON.parse(srcEl.textContent || '[]'); } catch (e) { sources = []; } }

      var el;
      var embed = (!sources.length && url) ? embedUrl(url) : null;
      if (embed) {
        el = document.createElement('iframe');
        el.src = embed;
        el.title = btn.getAttribute('aria-label') || 'Video';
        el.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        el.setAttribute('allowfullscreen', '');
      } else {
        el = document.createElement('video');
        el.controls = true;
        el.playsInline = true;
        el.setAttribute('playsinline', '');
        el.preload = 'auto';
        var cover = frame.querySelector('.video-feature__poster');
        if (cover && (cover.currentSrc || cover.src)) el.poster = cover.currentSrc || cover.src;
        /* Shopify serves several renditions. Offer only the formats this
           browser can play: adaptive HLS first (Safari), then MP4s from
           1080p down, so phones and desktops get a sensible size. */
        var hls = [], mp4 = [];
        for (var i = 0; i < sources.length; i++) {
          var s = sources[i];
          if (!s || !s.src || !el.canPlayType(s.type)) continue;
          if (/mpegurl/i.test(s.type)) hls.push(s); else mp4.push(s);
        }
        mp4.sort(function (a, b) {
          var aOk = a.h <= 1080, bOk = b.h <= 1080;
          if (aOk !== bOk) return aOk ? -1 : 1;
          return b.h - a.h;
        });
        var list = hls.concat(mp4);
        if (!list.length && url) list = [{ src: url, type: 'video/mp4' }];
        for (var j = 0; j < list.length; j++) {
          var se = document.createElement('source');
          se.src = list[j].src;
          se.type = list[j].type;
          el.appendChild(se);
        }
      }
      el.className = 'video-feature__media';
      frame.appendChild(el);
      frame.classList.add('is-playing');
      if (el.tagName === 'VIDEO') {
        el.focus();
        var p = el.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        el.focus();
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-video-play]') : null;
      if (!btn) return;
      var frame = btn.closest('[data-video-feature]');
      if (!frame || frame.classList.contains('is-playing')) return;
      load(frame, btn);
    });
  })();
